module.exports = __webpack_public_path__ + "fonts/fa-brands-400---822d94f19fe57477865209e1242a3c63.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-free/webfonts/fa-brands-400.woff2
// module id = 377
// module chunks = 0